import React from "react";
import { motion } from "framer-motion";
import { Check, Lock } from "lucide-react";
import ChapterHeading from "./ChapterHeading";
import { fadeUp, staggerParent, viewportOnce } from "../../lib/motion";

const apporte = [
  "Nouvelle enseigne & façade",
  "Peinture & charte graphique",
  "Présentoir fruits & légumes",
  "Merchandising du magasin",
  "Uniformes & formation",
  "Outils digitaux (app)",
  "Accompagnement terrain hebdomadaire",
];

const nechangeJamais = [
  "Reste propriétaire de son fonds",
  "Garde son personnel",
  "Garde sa clientèle",
  "Gère au quotidien comme avant",
];

export default function LeConcept() {
  return (
    <section id="le-concept" data-testid="le-concept-section" className="relative bg-diallo-sand py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <ChapterHeading number="02" kicker="Le concept" title="Votre boutique. En mieux." />
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Ce que Diallo apporte */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="rounded-3xl bg-diallo-red p-8 md:p-10 text-white shadow-[0_12px_40px_rgb(0,0,0,0.10)]"
            data-testid="concept-apporte"
          >
            <h3 className="font-display font-bold text-2xl md:text-3xl">Ce que Diallo apporte</h3>
            <p className="mt-2 text-white/80">Le kit de transformation, offert à 100 %.</p>
            <motion.ul variants={staggerParent} className="mt-7 space-y-3">
              {apporte.map((item) => (
                <motion.li key={item} variants={fadeUp} className="flex items-center gap-3">
                  <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white">
                    <Check size={16} color="#ED1C24" strokeWidth={3} />
                  </span>
                  <span className="text-white/95 md:text-lg">{item}</span>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          {/* Ce qui ne change jamais */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="rounded-3xl bg-white p-8 md:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
            data-testid="concept-nechange"
          >
            <h3 className="font-display font-bold text-2xl md:text-3xl text-diallo-charcoal">Ce qui ne change jamais</h3>
            <p className="mt-2 text-diallo-ink/60">Le commerçant reste maître chez lui.</p>
            <motion.ul variants={staggerParent} className="mt-7 space-y-3">
              {nechangeJamais.map((item) => (
                <motion.li key={item} variants={fadeUp} className="flex items-center gap-3">
                  <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-diallo-green/15">
                    <Lock size={15} color="#68AD45" strokeWidth={2.6} />
                  </span>
                  <span className="text-diallo-ink/90 md:text-lg">{item}</span>
                </motion.li>
              ))}
            </motion.ul>
            <div className="mt-8 rounded-2xl bg-diallo-sand p-5">
              <p className="text-diallo-charcoal font-medium">
                Même propriétaire. Même quartier. <br className="hidden sm:block" />
                Une toute nouvelle expérience.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Pull quote */}
        <motion.blockquote
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-16 max-w-4xl font-display font-extrabold text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-diallo-charcoal"
          data-testid="concept-pullquote"
        >
          « Votre boutique de quartier,{" "}
          <span className="text-diallo-red">en mieux. Pour tout le quartier.</span> »
        </motion.blockquote>
      </div>
    </section>
  );
}
